(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form-panel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', function (event) {
    var form = event.target.closest('.contact-form-panel__form');
    if (!form) return;

    // Honeypot: real visitors never see or tab into this field (see the
    // CSS and aria-hidden/tabindex on it); bots that blindly fill every
    // input on the page fill it too. Block the submission entirely —
    // both the native Shopify POST and the Klaviyo request below — rather
    // than letting it through.
    var honeypot = form.querySelector('[data-form-honeypot]');
    if (honeypot && honeypot.value !== '') {
      event.preventDefault();
      return;
    }

    // Minimum elapsed time since the form was rendered (set server-side,
    // not from JS, so it reflects actual page load rather than whenever
    // this script happened to run) — scripted bots typically fill and
    // submit in well under this, where a real visitor reading and
    // completing four fields won't.
    var renderedAtInput = form.querySelector('[data-form-rendered-at]');
    var renderedAt = renderedAtInput && parseInt(renderedAtInput.value, 10);
    if (renderedAt && Date.now() / 1000 - renderedAt < 3) {
      event.preventDefault();
      return;
    }

    var panel = form.closest('.contact-form-panel');
    var listId = panel && panel.dataset.klaviyoListId;
    var consentInput = form.querySelector('[data-klaviyo-consent]');
    if (!listId || !consentInput || !consentInput.checked) return;

    var emailInput = form.querySelector('input[type="email"]');
    var email = emailInput && emailInput.value;
    if (!email) return;

    var nameInput = form.querySelector('input[name="contact[name]"]');
    var nameParts = ((nameInput && nameInput.value) || '').trim().split(/\s+/);
    var cityInput = form.querySelector('input[name="contact[City]"]');
    var city = cityInput && cityInput.value;
    var messageInput = form.querySelector('textarea[name="contact[body]"]');
    var message = messageInput && messageInput.value;

    // Fired with keepalive so the request survives the native form
    // submission navigating away from the page right after this.
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=WUbcwU', {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: '2026-07-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Contact form panel',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: nameParts[0] || undefined,
                  last_name: nameParts.slice(1).join(' ') || undefined,
                  location: city ? { city: city } : undefined,
                  properties: message ? { customer_message: message } : undefined,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      })
    });
  });
  } catch(e) { console.error(e); }
})();

})();
